module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('div', {
    staticClass: "prvd__bg"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prvd__modal"
  }, [_c('div', {
    staticClass: "prvd__top"
  }, [_c('img', {
    staticClass: "prvd__conf prvd__conf__1",
    attrs: {
      "src": "/static/img/gus_2.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "prvd__conf prvd__conf__2",
    attrs: {
      "src": "/static/img/gus_1.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "conf__dot prvd__conf prvd__conf__3"
  }), _vm._v(" "), _c('div', {
    staticClass: "conf__smallring prvd__conf prvd__conf__4"
  }), _vm._v(" "), _c('div', {
    staticClass: "conf__dot prvd__conf prvd__conf__5"
  }), _vm._v(" "), _c('div', {
    staticClass: "conf__dot prvd__conf prvd__conf__6"
  }), _vm._v(" "), _c('div', {
    staticClass: "conf__bigring prvd__conf prvd__conf__7"
  }), _vm._v(" "), _c('img', {
    staticClass: "prvd__conf prvd__conf__8",
    attrs: {
      "src": "/static/img/gus_2.svg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "prvd__prelude"
  }, [_vm._v("Ты получил:")]), _vm._v(" "), _c('div', {
    staticClass: "prvd__reward"
  }, [_c('p', {
    staticClass: "prvd__val"
  }, [_vm._v("15")]), _vm._v(" "), _c('p', {
    staticClass: "prvd__word"
  }, [_vm._v("Баллов")])]), _vm._v(" "), _c('div', {
    staticClass: "popup__progress"
  }, [_c('div', {
    staticClass: "popup__progress__top"
  }, [_c('p', {
    staticClass: "popup__progress__currentlvl"
  }, [_vm._v("2 Уровень")]), _vm._v(" "), _c('p', {
    staticClass: "popup__progress__lvlprogress"
  }, [_c('span', [_vm._v("20")]), _vm._v(" / 40 баллов")])]), _vm._v(" "), _c('div', {
    staticClass: "popup__progress__bar__container"
  }, [_c('div', {
    staticClass: "popup__progress__bar"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "popup__bottom"
  }, [_c('p', {
    staticClass: "popup__bottom__about"
  }, [_c('span', {
    staticClass: "popup__bottom__link"
  }, [_vm._v("Подробнее о программе лояльности")])]), _vm._v(" "), _c('div', {
    staticClass: "popup__bottom__button"
  }, [_vm._v("Закрыть")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104b3bc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/points-received.vue
// module id = 288
// module chunks = 1